//#region src/order_status.ts
var OrderStatus = /* @__PURE__ */ function(OrderStatus) {
	OrderStatus["Transmitting"] = "transmitting";
	OrderStatus["OnHold"] = "on-hold";
	OrderStatus["InProgress"] = "in-progress";
	OrderStatus["Completed"] = "completed";
	OrderStatus["DeliveryInProgress"] = "delivery-in-progress";
	OrderStatus["Delivered"] = "delivered";
	OrderStatus["Cancelled"] = "cancelled";
	OrderStatus["GiveUp"] = "give-up";
	OrderStatus["Unknown"] = "unknown";
	return OrderStatus;
}(OrderStatus || {});
//#endregion
export { OrderStatus };

//# sourceMappingURL=order_status.js.map